
import { Component, Vue } from 'vue-property-decorator'
import CardListList from '@/components/company/cardList/CardListList.vue'

@Component({
  name: 'CardLists',
  components: { CardListList }
})
class CardLists extends Vue {}

export default CardLists
